<script>
import salesApi from "@/api/web/bi/sales.js";
// import common from "@/common/mixins/common.js";
import Vue from "vue";

export default {
  // 接收父组件传递过来的值
  props: {
    // 商品类型
    goodsTypes: {
      type: Array,
      default: () => [],
    },
    // 语言
    lang: {
      type: String,
      default: "",
    },
    pickerOptions: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      tableData: [],
      query: {
        page: 1,
        size: 10,
        total: 100,
        type: "",
        time2: "",
        goodsTypeValue: "",//商品类型[用于提交]
      },
      goodsTypeValue: "",  // 查询商品类型
      sale_time: [], // 销售时间
      shop_time: [], // 补货时间
      jxShow: {}, // 显示营销数据占比
      lsShow: {}, // 历史
      ndxdShow: {}, // 拟下单金额
    };
  },
  created() {
    this.getData();
  },
  // 监听goodsTypeValue参数
  watch: {
    goodsTypeValue(newValue, oldValue) {
      this.query.goodsTypeValue = newValue[newValue.length - 1];
    },
    time2(newValue, oldValue) {
      this.query.time2 = [];
      this.query.time2 = newValue[0] + "-" + newValue[1];
    },
  },
  methods: {
    getData() {
      this.tableData = [];
      let find_query = {}
      // 处理时间
      find_query = {
        page: this.query.page,
        size: this.query.size
      }
      if (this.sale_time.length > 0) {
        find_query.sale_time = parseInt(this.sale_time[0]/1000) + "-" + parseInt(this.sale_time[1]/1000);
      }
      if (this.shop_time.length > 0) {
        find_query.shop_time = parseInt(this.shop_time[0]) + "-" + parseInt(this.shop_time[1]);
      }
      if (this.query.goodsTypeValue) {
        find_query.goods_type_value = this.query.goodsTypeValue;
      }
      salesApi.getSalesList(find_query).then(res => {
        const resD = res.data.data;
        this.tableData = this.filterData(resD.list);        
        this.query.total = resD.total;
      });
    },
    filterData(datas) { 
      let processedItems = datas.map(item => {
        /*
        "saleSum": 0, 销售数量
        "salesAmount": 0,销售金额

        "hy_sl_num": 0, 历史总销量
        "hy_sl_price": 0,历史总销金额

        "supply_num": 12,补货总数量
        "supply_price": 32.4,补货总金额
        */
        let jxzb = 1
        let lszbi = 1
        let ndxzb = 1
        if (item.salesAmount > 0 && item.supply_price > 0){
          jxzb = (item.saleSum / item.salesAmount * 100).toFixed(2) + "%"
        } else {
          jxzb = "0%"
        }
        // 历史总占比
        if (item.saleSum > 0 && item.supply_num > 0){
          lszbi = (item.hy_sl_num / item.supply_num * 100).toFixed(2) + "%"
        } else {
          lszbi = "0%"
        }
        
        if (item.FdOrderNum > 0 && item.hy_sl_num > 0){
          ndxzb = (item.FdOrderNum / item.hy_sl_num * 100).toFixed(2) + "%"
        } else {
          ndxzb = "0%"
        }
        let imageurl = `https://hwimg.xmvogue.com/thumb/${item.sku}.jpg?x-oss-process=style/440`;
        return {
          sku: item.sku,
          cn_name: item.cn_name,
          en_name: item.en_name,
          images: imageurl,
          sale_num: item.sale_num,
          price: item.price,
          sale_time: item.sale_time,
          shop_time: item.shop_time,
          goods_type_value: item.goods_type_value,
          jxzb: jxzb,
          lszbi: lszbi,
          ndxzb: ndxzb
        }
      });
      return processedItems;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData();
    },
    findQuery() {
      this.getData();
    },
  },
};
</script>

<template>
  <div>
    <div class="selType">
      分类:
      <el-cascader v-model="goodsTypeValue" :options="goodsTypes" :placeholder="$t('Please Select Product Category')"
                   :props="{ checkStrictly: true }" clearable size="medium" style="width: 260px">
      </el-cascader>
      &nbsp;&nbsp;&nbsp;
      销售时间:
      <el-date-picker
        v-model="sale_time"
        :picker-options="pickerOptions"
        align="right"
        end-placeholder="结束日期"
        range-separator="至"
        start-placeholder="开始日期"
        type="datetimerange"
        value-format="timestamp">
      </el-date-picker>
      <el-button icon="el-icon-search" size="mini" type="primary" @click="findQuery">搜索</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        label="sku"
        prop="sku"
        width="150">
      </el-table-column>
      <el-table-column
        align="center"
        label="图片" width="80">
        <template slot-scope="{row}">
          <viewer>
            <img :src="row.images" height="30"
                 style="cursor: pointer;" width="30">
          </viewer>
        </template>
      </el-table-column>

      <el-table-column label="产品名称" prop="address">
        <template v-slot="scope">
          <span v-if="lang == 'en'">{{ scope.row.en_name ?  scope.row.en_name : scope.row.cn_name}}</span>
          <span v-else>{{ scope.row.cn_name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="销售金额占比" width="150">
        <template slot-scope="{row}">
          <div>{{ row.jxzb }}</div>
        </template>
      </el-table-column>

      <el-table-column label="历史补货占比" prop="type" width="150">
        <template slot-scope="{row}">
          <div>{{ row.lszbi }}</div>
        </template>
      </el-table-column>

      <el-table-column label="拟下单金额占比" prop="type" width="150">
        <template slot-scope="{row}">
          <div>{{ row.ndxzb }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination :page-size="query.size" :total="query.total" layout="total, prev, pager, next"
                     style="margin-top: 10px;"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.selType {
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px 5px;
}
</style>